/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropprizevalue2Inputs */

const en_dropprizevalue2 = /** @type {(inputs: Dropprizevalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prize value (EUR, optional)`)
};

const de_dropprizevalue2 = /** @type {(inputs: Dropprizevalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinnwert (EUR, optional)`)
};

/**
* | output |
* | --- |
* | "Prize value (EUR, optional)" |
*
* @param {Dropprizevalue2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropprizevalue2 = /** @type {((inputs?: Dropprizevalue2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropprizevalue2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropprizevalue2(inputs)
	return de_dropprizevalue2(inputs)
});
export { dropprizevalue2 as "dropPrizeValue" }